import type { FriendsPeriod } from "./FRIENDS_PERIODS";
import type { FriendPlayer } from "./FriendsBoard";
import { metricValue } from "./metricValue";

export type AwardKind = "marathon" | "farmer" | "immortal" | "sponsor" | "riser";

export type Award = {
  kind: AwardKind;
  player: FriendPlayer;
  // Матчей, душ в минуту, смертей за матч или прирост общей оценки.
  value: number;
};

type Rule = {
  kind: AwardKind;
  value: (player: FriendPlayer) => number | null;
  higherIsBetter: boolean;
};

const growth = (player: FriendPlayer): number | null =>
  player.current.score === null || player.previous_score === null
    ? null
    : player.current.score - player.previous_score;

const RULES: readonly Rule[] = [
  { kind: "marathon", value: (player) => player.current.matches, higherIsBetter: true },
  {
    kind: "farmer",
    value: (player) => metricValue("soulsPerMinute", player.current),
    higherIsBetter: true,
  },
  {
    kind: "immortal",
    value: (player) => metricValue("deaths", player.current),
    higherIsBetter: false,
  },
  {
    kind: "sponsor",
    value: (player) => metricValue("deaths", player.current),
    higherIsBetter: true,
  },
  { kind: "riser", value: growth, higherIsBetter: true },
];

// Номинации периода среди тех, кто за него играл. Меньше двух игроков — не с кем
// соревноваться, номинаций нет. «Рывок» — только с ростом оценки и не за всю историю:
// там не с чем сравнивать. При равенстве побеждает тот, кто выше в списке.
export const awards = (players: readonly FriendPlayer[], period: FriendsPeriod): Award[] => {
  const active = players.filter((player) => player.current.matches > 0);
  if (active.length < 2) {
    return [];
  }
  return RULES.flatMap((rule) => {
    if (rule.kind === "riser" && period === "all") {
      return [];
    }
    let best: Award | null = null;
    for (const player of active) {
      const value = rule.value(player);
      if (value === null) {
        continue;
      }
      if (best === null || (rule.higherIsBetter ? value > best.value : value < best.value)) {
        best = { kind: rule.kind, player, value };
      }
    }
    if (best === null || (rule.kind === "riser" && best.value <= 0)) {
      return [];
    }
    return [best];
  });
};
